import { Component } from 'react';
import { BlockInstanceProps } from '../Block';
import {
  ContentTypeEnum,
  KeyFigureGridTypeEnum,
  fontColorEnum,
  BackgroundColorEnum,
} from '../../constants/cms-constants';
import KeyFigureGridComponent from '../../components/KeyFigureGridComponent';
import {
  ComponentWithControlOptions,
  ControlOption,
} from '../../utils/controlOptions/ControlOptionDecorator';
import controlOptionDefinitions from '../../utils/controlOptions/controlOptionDefinitions';

@ControlOption([
  {
    key: 'backgroundColor',
    definition: controlOptionDefinitions.backgroundColor,
  },
  {
    key: 'fontColor',
    definition: controlOptionDefinitions.fontColor,
  },
  {
    key: 'gridType',
    definition: controlOptionDefinitions.keyFigureGridTypes,
  },
])
class KeyFigureGrid extends ComponentWithControlOptions<BlockInstanceProps> {
  render() {
    const { block, blockContent } = this.props;
    const controlOptions = block?.controlOptionsV2;
    const backgroundColor =
      BackgroundColorEnum[controlOptions?.backgroundColor];
    const fontColor = fontColorEnum[controlOptions?.fontColor];
    const gridType = KeyFigureGridTypeEnum[controlOptions?.gridType];

    let mediaItems;
    blockContent.doQuery((content) => {
      mediaItems = content.getAllOfType(ContentTypeEnum.MEDIAITEM);
    });

    return (
      <KeyFigureGridComponent
        mediaItems={mediaItems}
        gridType={gridType}
        backgroundColor={backgroundColor}
        fontColor={fontColor}
      />
    );
  }
}
export default KeyFigureGrid;
